"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[959],{

/***/ 3959:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ LinkTo)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



function LinkTo({ wrapper }) {
    const $trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)

    const prohibitedElements = ['a', 'button', 'input', 'select'];

    //
    ; (function () {
        $trigger.onDraglessClick(redirectFromTrigger)
    })()

    function redirectFromTrigger(event) {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).closest(prohibitedElements.join(', ')).length) return

        location = $trigger.data('link')
    }
}


/***/ })

}]);